import { gsap, ScrollTrigger, Power2 } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

class ParallaxImage {
  constructor() {
    this.images = gsap.utils.toArray('.js-parallax .tease');
    this.tlScrub = {};
    this.assetLength = Number(document.querySelector('.js-parallax').dataset.assetLength);
    this.animate();
  }

  animate() {
    this.images.forEach(image => {
      const width = this.getWidth(image.getBoundingClientRect().width);

      ScrollTrigger.matchMedia({
        '(min-width: 768px)': () => {
          this.tlScrub = gsap.timeline({
            scrollTrigger: {
              trigger: '.js-parallax',
              start: 'top center',
              end: `bottom center`,
              scrub: true,
            },
          });

          this.tlScrub.fromTo(
            image,
            {
              yPercent: width,
              ease: Power2,
            },
            {
              duration: 0.5,
              yPercent: width * -1,
              ease: Power2,
            },
          );
        },
      });
    });
  }

  getWidth(w) {
    return (w / window.innerWidth) * 100;
  }

  randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

export default ParallaxImage;
